import { Pie, PieChart, PieLabelRenderProps, PieSectorShapeProps, Sector, Tooltip, TooltipIndex } from 'recharts';


// #region Sample data


// #endregion
const RADIAN = Math.PI / 180;
const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#77d439'];

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }: PieLabelRenderProps) => {
  if (cx == null || cy == null || innerRadius == null || outerRadius == null) {
    return null;
  }
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const ncx = Number(cx);
  const x = ncx + radius * Math.cos(-(midAngle ?? 0) * RADIAN);
  const ncy = Number(cy);
  const y = ncy + radius * Math.sin(-(midAngle ?? 0) * RADIAN);

  return (
    <text x={x} y={y} fill="white" textAnchor={x > ncx ? 'start' : 'end'} dominantBaseline="central">
      {`${((percent ?? 1) * 100).toFixed(2)}%`}
    </text>
  );
};

const MyCustomPie = (props: PieSectorShapeProps) => {
  return <Sector {...props} fill={COLORS[props.index % COLORS.length]} />;
};
const compactIN = (num) =>
    new Intl.NumberFormat('en-IN', {
      notation: 'compact',
      compactDisplay: 'short',
      maximumFractionDigits: 1,
  }).format(num);

const CustomTooltip = ({ active, payload, label }: TooltipContentProps<string | number, string>) => {
  if (!payload[0]) return null;

  //console.log('payload===',payload[0]?.payload.color)
  
  const isVisible = active && payload && payload.length;
  return (
    <div className={`bg-black text-white px-3 py-1 rounded shadow-lg`} style={{ visibility: isVisible ? 'visible' : 'hidden' }}>
      {isVisible && (
        <>
          <p className="label">{`${payload[0].name} : ${payload[0].value}%`}</p>
          <p className="desc">{`Number of Shares: ${compactIN(payload[0].payload.total)}`}</p>
        </>
      )}
    </div>
  );
};

export default function InvestorChart({shareholders, view, displayKeys}) {
  //console.log('displayKeys====:===',Object.values(displayKeys).at(-1))
  if (!shareholders?.DII) return null;
  
  let yearkey = Object.values(displayKeys).at(-1);

  /* let DIIItem = Object.values(shareholders.DII?.[""] ?? {}).at(-1);
  let FIIItem = Object.values(shareholders.FII?.[""] ?? {}).at(-1);
  let PromotersItem = Object.values(shareholders.Promoters?.[""] ?? {}).at(-1);
  let PublicItem = Object.values(shareholders.Public?.[""] ?? {}).at(-1);
  let GovernmentItem  = Object.values(shareholders.Government?.[""] ?? {}).at(-1); */

  let result = yearkey;
  if(view == 'Yearly'){
    result = yearkey.replace(/[A-Za-z]/g, "").trim();
  }
  //if(view == 'Yearly'){

    let DIIItem = shareholders.DII?.[""]?.[yearkey] ?? null;
    let FIIItem = shareholders.FII?.[""]?.[yearkey] ?? null;
    let PromotersItem = shareholders.Promoters?.[""]?.[yearkey] ?? null;
    let PublicItem = shareholders.Public?.[""]?.[yearkey] ?? null;
    let GovernmentItem = shareholders.Government?.[""]?.[yearkey] ?? null;
  //}
  //console.log('PromotersItem====',shareholders.Promoters)

  const data = [
    { 
      name: 'Promoters', 
      value: Number(PromotersItem?.percent_holding), 
      total:PromotersItem?.number_of_shares,
      color:'#0088FE', 
    },
    { 
      name: 'DII', 
      value: Number(DIIItem?.percent_holding), 
      total:DIIItem?.number_of_shares, 
      color:'#00C49F',
    },
    { 
      name: 'FII', 
      value: Number(FIIItem?.percent_holding), 
      total:FIIItem?.number_of_shares,
      color:'#FFBB28',
    },
    { 
      name: 'Public', 
      value: Number(PublicItem?.percent_holding), 
      total:PublicItem?.number_of_shares,
      color:'#FF8042',
    },
    { 
      name: 'Government', 
      value: Number(GovernmentItem?.percent_holding), 
      total:GovernmentItem?.number_of_shares,
      color:'#77d439',
    }
  ].filter(item => Number.isFinite(item.value));

  return (
    <div className='flex flex-col lg:flex-row items-center justify-center gap-5'>
    <PieChart style={{ width: '100%', maxWidth: '300px', maxHeight: '80vh', aspectRatio: 1 }} responsive>
      <Pie
        data={data}
        labelLine={false}
        /* label={renderCustomizedLabel} */
        fill="#8884d8"
        dataKey="value"
        isAnimationActive={true}
        shape={MyCustomPie}
      />
      <Tooltip content={CustomTooltip} />
    </PieChart>
    <div>
      <div className='text-lg font-semibold mb-2'>Pie Chart {view} ({result})</div>
      {
        data && data.map((val, key) =>(
          <div className='flex items-center gap-2 mb-2' key={`chart-data-${key}`}>
            <div className={`w-3 h-4`} style={{backgroundColor:val.color}}></div>
            <div>{val.name}:</div>
            <div>{val.value}%</div>
          </div>
        ))
      }
    </div>
    </div>
  );
}